'use strict';

var Carousel = require('./carousel');
var Experts = require('./experts');
var is = require('../services/is');
var blzEvent = require('../services/tracking/blz-event.js');
var { handleLazyShelfDataLayerEvents } = require('./dataLayerEC');

document.addEventListener('lazyincluded', function (e) {
  var dataInteraction = $(e.target).find('[data-interaction-load]').data('interaction-load');

  if (e.target.getAttribute('data-carousel')) {
    // TODO adicionar disparo do evento de productImpression
    Carousel.render();
    handleLazyShelfDataLayerEvents(e.target.querySelectorAll('[data-event]'));
  }

  if (e.target.getAttribute('data-current-user')) {
    blz.currentUser();
  }

  if (e.target.getAttribute('data-slot-experts-posts')) {
    Experts.init();
  }

  dataInteraction && blzEvent.interaction({}, dataInteraction);

  ((blz || {}).dataLayer || {}).impressions();
});

document.addEventListener('lazyincludeloaded', function (e) {
  if (!e.detail.isSuccess) return;

  if (e.target.getAttribute('data-outer-html') && e.detail.content) {
    e.target.outerHTML = e.detail.content;
  } else {
    e.target.innerHTML = e.detail.content;
  }
});

$(document).click(function (event) {
  window.uiClick = event.target.className;
});

if (navigator.share) {
  $('.js-share').on('click', function () {
    navigator.share({
      title: 'Compartilhe este produto',
      url: window.location.href
    });
  });
}

$('.select-country select').on('change', function (event) {
  event.preventDefault();
  var destination = $(this).val();
  if (is.iphone()) {
    window.location.href = destination;
  } else {
    window.open(destination);
  }
});
